import { PropsWithChildren } from 'react';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';
import { useNormalizedCompetitionRegistrationCategoryListQuery } from '../queries';
import { RegistrationCategoriesContext } from './registration-categories-context';

export function RegistrationCategoriesProvider({ children }: PropsWithChildren) {
  const { id } = useParams(idParamSchema.parse);

  const { data: categories = [], isRefetching, isLoading } = useNormalizedCompetitionRegistrationCategoryListQuery(id);

  const noWeightClass = categories.length > 0 && categories.every(c => c.weight_classes.length === 0);

  return (
    <RegistrationCategoriesContext.Provider value={{ categories, isRefetching, isLoading, noWeightClass }}>
      {children}
    </RegistrationCategoriesContext.Provider>
  );
}
